/** High-quality JPEG export (balance of size and fidelity). */
export const JPEG_EXPORT_QUALITY = 0.95;

export async function canvasToJpegBlob(
  canvas: HTMLCanvasElement,
  quality: number = JPEG_EXPORT_QUALITY
): Promise<Blob> {
  const blobFromToBlob = await new Promise<Blob | null>(resolve => {
    if (typeof canvas.toBlob !== 'function') {
      resolve(null);
      return;
    }

    canvas.toBlob(resolve, 'image/jpeg', quality);
  });

  if (blobFromToBlob && blobFromToBlob.size > 0) {
    return blobFromToBlob;
  }

  if (typeof canvas.toDataURL === 'function') {
    const dataUrl = canvas.toDataURL('image/jpeg', quality);
    const response = await fetch(dataUrl);
    const fallbackBlob = await response.blob();

    if (fallbackBlob.size > 0) {
      return fallbackBlob;
    }
  }

  throw new Error('JPEG conversion failed');
}

export async function yieldToMainThread(): Promise<void> {
  await new Promise<void>(resolve => {
    window.setTimeout(resolve, 0);
  });
}

export const JPEG_YIELD_EVERY_N_IMAGES = 4;
